/**
 * Query key functions that are passed to the useQuery hook 
 * to uniquely identify an API call. The returned keys allow 
 * components to take advantage of tanstack query's caching 
 * so results can be shared across multiple components so 
 * calls to the same API method with the same arguments can be 
 * loaded from cache.
 */

// /competition/:id
export const keyCompetitionWithId = (competitionId: string) => {
    return ["competition", competitionId];
}

// /competition/all
export const keyCompetitionAll = () => {
    return ["competition", "all"];
}

// /competition/eligible
export const keyCompetitionEligible = () => {
    return ["competition", "eligible"];
}

// /competition/:id/jumps
export const keyCompetitionWithIdJumps = (competitionId: string) => {
    return ["competition", competitionId, "jumps"]
}

// /competition/:id/organizers
export const keyCompetitionWithIdOrganizers = (competitionId: string) => {
    return ["competition", competitionId, "organizers"];
}

// /competition/jump/:id
export const keyCompetitionJumpWithId = (jumpId: string) => {
    return ["competition",  "jumpId", jumpId];
}

// /competition/jump/:id/business_info
export const keyCompetitionJumpWithIdBusinessInfo = (jumpId: string) => {
    return ["competition",  "jump", jumpId, "business_info"];
}

// /competition/jumps
export const keyCompetitionJumps = () => {
    return ["competition",  "jumps"];
}

// /competition/:id/judges
export const keyCompetitionWithIdJudges = (competitionId: string) => {
    return ["competition", competitionId, "judges"];
}

// /competition/jump/:id/reviewers
export const keyCompetitionJumpWithIdReviewers = (jumpId: string) => {
    return ["competition", "jump", jumpId, "reviewers"];
}

// /competition/jump/:id/team
export const keyCompetitionJumpWithIdTeamMembers = (jumpId: string) => {
    return ["competition", "jump", jumpId, "team"];
}

// /competition/:id/competitors
export const keyCompetitionWithIdCompetitors = (competitionId: string) => {
    return ["competition", competitionId, "competitors"];
}

// /competition/:id/asset/favorite
export const keyCompetitionWithIdAssetFavorite = (competitionId: string) => {
    return ["competition", competitionId, "asset", "favorite"]
}

// /competition/jump/:id/asset/favorite
export const keyJumpWithIdAssetFavorite = (jumpId: string) => {
    return ["competition", "jump", jumpId, "asset", "favorite"]
}

// /competition/categories
export const keyCompetitionCategories = () => {
    return ["competition", "categories"];
}

// /competition/jump/recent
export const keyMostRecentDraftJump = () => {
    return ["competition", "jump", "draft", "last"];
}

// /competition/elegible/count
export const keyCompetitionElegibleCount = () => {
    return ["competition", "elegible", "count"];
}

// /competition/guest/:magicId
export const keyGetInvitedGuestInfo = (magicId: string) => {
    return ["competition", "guest", magicId];
}

// /asset/:id/urls
export const keyAssetWithIdUrls = (id: string) => {
    return ["asset", id, "urls"];
}

// /asset/:id/thumbnail
export const keyAssetWithIdThumbnail = (id: string) => {
    return ["asset", id, "thumbnail"];
}


// /asset/jump/:id
export const keyAssetJumpWithId = (jumpId: string) => {
    return ["asset", "jump", jumpId];
}

// /asset/competition/:id
export const keyAssetCompetitionWithId = (competitionId: string) => {
    return ["asset", "competition", competitionId];
}


// /asset/thumbnail/competition/:id
export const keyAssetThumbnailCompetitionWithId = (competitionId: string) => {
    return ["asset", "thumbnail", "competition", competitionId];
}

// /asset/thumbnail/jump/:id
export const keyAssetThumbnailJumpWithId = (jumpId: string) => {
    return ["asset", "thumbnail", "jump", jumpId];
}

// /asset/selected/jump/:id
export const keyAssetSelectedJumpWithId = (jumpId?: string) => {
    if (jumpId == null) {
        return [];
    }
    return ["asset", "thumbnail", "jump", jumpId];
}

// /asset/selected/competition/:id
export const keyAssetSelectedCompetitionWithId = (competitionId?: string) => {
    if (competitionId == null) {
        return [];
    }
    return ["asset", "thumbnail", "competition", competitionId];
}

// /activities/:id
export const keyActivitiesWithId = (activityId: string) => {
    return ["activities", activityId];
}

// /security/authorization
export const keySecurityAuthorization = () => {
    return ["security", "authorization"];
}


// /utility/linkpreview/:url
export const keyUtilityLinkPreviewWithUrl = (url: string) => {
   return ['utility', 'linkpreview', url];
}

// /profile
export const keySessionUserProfile = () => {
    return ['profile'];
}

// /profile/:email
export const keyProfile = (email: string) => {
    return ['profile', email];
}

// /profile/:email/avatar
export const keyProfileAvatar = (email: string) => {
    return ['profile', email, 'avatar'];
}

export const keyGetUserProfilePictureUrl = (id: string = "null") => {
    return ['profile', id, 'picture'];
}

export const keyActivitiesForJump = (jumpId: string, guest?: boolean) => {
    let guestElement;
    if (guest) {
        guestElement = "?guest"
    }
    return ['activities', 'jump', jumpId, guestElement ];
}

export const keySubscriptionProducts = () => {
    return ['subscription', 'products'];
}


